/**
 * flsServices()
 * Register Angular Services
 *
 * @package:  Betta
 * @version:  2.0
 * @author:   Cyrill N KALITA
 */

var flsServices = angular.module('flsServices', ['ngResource']);

require('./services/hcp');
require('./services/caterer');
require('./services/contractType');
require('./services/cost');
require('./services/costType');
require('./services/note');
require('./services/template');
require('./services/program');
require('./services/brand');
require('./services/venue');
require('./services/address');
require('./services/field');
require('./services/certification');
require('./services/backgroundCheck');
require('./services/profile');
require('./services/budget');
require('./services/lodash');
